import {
    NavController,
    NavParams,
    App,
    ModalController,
    ViewController,
    ToastController,
} from "ionic-angular";
import { Storage } from "@ionic/storage";
import { Component, OnInit, Input } from "@angular/core";

import { AuthProvider } from "../../../../providers/auth/auth";
import { EmployeeRhProvider } from "../../../../providers/employeerh/employeerh";
import { KnowledgeProvider } from "../../../../providers/knowledge/knowledge";
import { RhKnowledgePagePage } from "./knowledge-page/knowledge-page";

@Component({
    selector: "page-rh-knowledge",
    templateUrl: "rh-knowledge.html",
})
export class RhKnowledgePage implements OnInit {

   categories: any = [];
   companyPage: any;

   // DOM conditioning
   deployedCategoryId:string = null;
   domType;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public storageProvider: Storage,
        public app: App,
        public authProvider: AuthProvider,
        public employeeRhProvider: EmployeeRhProvider,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController,
        public modalCtrl: ModalController,
        private knowledgeProvider: KnowledgeProvider
    ) {
        this.domType = this.navParams.get("domType");
    }

    ngOnInit() {
        this.loadDatas();
    }

    loadDatas() {
        this.knowledgeProvider.listCategories().subscribe((res) => {
            if (res.success) {
                this.categories = res.data;
            }
        })

        this.knowledgeProvider.getCompanyPage().subscribe((res) => {
            if (res.success) {
                this.companyPage = res.data;
            }
        })

    }

    goToPage(id:string) {
        let modalView = this.modalCtrl.create(RhKnowledgePagePage, {id}, {
          cssClass: 'my-popover'
        });
        modalView.onDidDismiss(() => {
          this.loadDatas()
        })
        modalView.present().then(() => {});
      }

    // Modal ctrl
    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-knowledge/rh-knowledge.ts